import React from 'react'

import { type EntityId, type EntityState } from '@reduxjs/toolkit'
import { type ExperienceCard } from '../../types/types'
import { useNavigate } from 'react-router-dom'
import ExperienceListPresentation from '../../../experience/presentation/expereince.list.presentation/ExperienceListPresentation'


interface ExperienceListContainerPorps {
  list: EntityState<ExperienceCard>
  onSort: (fieldName: string) => void
  sort: string
  page?: number
  limit?: number
  onPage?: (pageNumber: number) => void
  onLimit?: (limitNumber: number) => void
  onDelete: (id: EntityId) => void
}


const ExperiecneListContainer: React.FC<ExperienceListContainerPorps> = ({
  list,
  onSort,
  sort,
  page,
  limit,
  onPage,
  onLimit,
  onDelete
}) => {

  const navigation = useNavigate()


  const onEditHanlder = (id: EntityId) => {
    navigation(`/experience/expdetails/${id}`,{state : {isPrerequisites : false}
    
    })
  }


 
  const onPlusHanlder = (id: EntityId) => {
    navigation(`/experience/expdetails/${id}`,{state : {isPrerequisites : true}
    
    })
  }

  const onReviewHandler = (id: EntityId) => {
    navigation(`/experience/expReview/${id}`)
  }
  return (
    // return the persentation
    <ExperienceListPresentation
      list={list}
      onEdit={onEditHanlder}
      onPlus={onPlusHanlder}
      onReview={onReviewHandler}
      onDelete={onDelete}
      onSort={onSort}
      sort={sort}
      page={page}
      limit={limit}
      onLimit={onLimit}
      onPage={onPage}
     
    />
  )
}

export default ExperiecneListContainer
